import React, { useState, useEffect, useRef, forwardRef, } from "react";
import ttAPI from '../../api/ttAPI';
import { CircularProgress, Tooltip, IconButton,  MenuItem, Menu, ListItemIcon, ListItemText } from "@material-ui/core";
import { Link } from '../../components/Wrappers'
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
// components
import { withStyles } from '@material-ui/core/styles';

// Icons
import {
    Add as AddIcon,
    Chat as ChatIcon,
    MoreVert as MoreVertIcon,
    History as  HistoryIcon
} from '@material-ui/icons'

import useStyles from './accounts_table_styles';
import config from '../../config';

const AccountsTable = forwardRef((props, ref) => {
  // global
  const classes = useStyles();
  const history = useHistory();

  // local
  var [data, setData] = useState([]);
  var [key, setKey] = useState(undefined);
  var [isLoading, setIsLoading] = useState(false);
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.primary.main,
          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
            color: theme.palette.common.white,
          },
        },
      },
    }))(MenuItem);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);


  const columns = [
    { label: 'ID', name: 'id', options: {filter: false, display: false, searchable: false}},
    { label: 'SIGNON', name: 'signon', options: {filter: true, display: false, download: true}},
    { label: 'Name', name: 'name', options: {filter: true, display: false, download: true}},
    { label: 'Name', name: 'name',
      options: {
        filter: false,
        download: false,
        customBodyRender: (value, tableMeta) => {

          return (<div className={classes.imageNameColumn}>
                      <div className={classes.accountImageDiv}>
                      <img className={classes.accountImage} alt={`${tableMeta.rowData[2]}` - `${tableMeta.rowData[1]}`}
                           src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${tableMeta.rowData[0]}?${getRandomInt(1000000)}`}/>
                      </div>
                      <div style={{ paddingLeft: '10px' }}>{tableMeta.rowData[2]}<br/>{tableMeta.rowData[1]}<br/>{tableMeta.rowData[12]}<br/>{tableMeta.rowData[13]}</div>
                      </div>);
        }}
    },
    /*{
        name: "name_signon",
        label: "Name and SIGNON",
        options: {
            filter: false,
            sort: true,
            searchable: false,
            download: false,
            customBodyRender: (value, tableMeta) => {
                return  (<div className={classes.imageNameColumn}>
                            <div className={classes.accountImageDiv}>
                            <img className={classes.accountImage}
                                 src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${tableMeta.rowData[0]}?${getRandomInt(1000000)}`}/>
                            </div>
                            <span style={{ paddingLeft: '10px' }}>{tableMeta.rowData[2]}</span></div>);
            }
        }
    },*/
    { label: 'Level', name: 'level', options: {filter: true, display: true, searchable: false}},
    { label: 'Region', name: 'franchise_name'},
    { label: 'ACCOUNT ACCESS', name: 'account_access',
      options: {
        customFilterListOptions: {
                  render: v => {
                    return `Account Access: ${v}`;
                  },
        }
      }},
    { label: 'REGION ACCESS', name: 'franchise_access',
      options: {
        customFilterListOptions: {
                  render: v => {
                    return `Region Access: ${v}`;
                  },
        }
      }},
    { label: 'CUSTOMER ACCESS', name: 'customer_access',
      options: {
        customFilterListOptions: {
                  render: v => {
                    return `Customer Access: ${v}`;
                  },
        }
      }},
      { label: 'VAX PROOF', name: 'proof_access',
        options: {
          customFilterListOptions: {
                    render: v => {
                      return `Vax Proof: ${v}`;
                    },
          }
        }},
        { label: 'FIRE KIT', name: 'fire_kit',
          options: {
            customFilterListOptions: {
                      render: v => {
                        return `Fire Kit: ${v}`;
                      },
            }
          }},
    { label: 'Active',
      name: 'active',
      options: {
        filter: true,
        filterList: (localStorage.getItem('accounts_filter_list') === undefined || localStorage.getItem('accounts_filter_list') === null || JSON.parse(localStorage.getItem('accounts_filter_list'))[11].length == 0) ? [] : JSON.parse(localStorage.getItem('accounts_filter_list'))[11],
        customFilterListOptions: {
                  render: v => {
                    return `Active: ${v}`;
                  },
        }
      }
    },
    { label: 'email', name: 'email', options: {filter: false, display: false, searchable: true, download: true}},
    { label: 'phone', name: 'phone', options: {filter: false, display: false, searchable: true, download: true}},

    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          download: false,
          sort: false,
          empty: true,
          customBodyRenderLite: (dataIndex) => {
            return (<div>
              <IconButton color="primary"
                          component="span"
                          onClick={handleClick}>
                  <MoreVertIcon />
              </IconButton>
              <StyledMenu
                  id="customized-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}

                >
                <StyledMenuItem onClick={downloadHistory}>
                  <ListItemIcon>
                    <HistoryIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Download History" />
                </StyledMenuItem>
                  <StyledMenuItem onClick={openTeamChat}>
                    <ListItemIcon>
                      <ChatIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Open Chat" />
                  </StyledMenuItem>
                </StyledMenu>


                </div>
            );
          }
        }
      },
  ];

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '16px 16px',
           },
       },
     }
   });


    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
       if(mounted){
         setIsLoading(true);
         const response = props.all ? await ttAPI.getAllAccounts() : await ttAPI.getAllTestntelAccounts();
         if (response !== null) {
            setData(response);
            setIsLoading(false);
          }
         }
       };
       if ((data === null || data === undefined || data.length === 0) && !isLoading && (key === undefined || key === null || key === '' || key.length < 2)){
          fetchData();
       }

       return () => mounted = false;

    }, [isLoading, data, key]);

    async function refreshData() {
      const response = props.all ? await ttAPI.getAllAccounts() : await ttAPI.getAllTestntelAccounts();
      setData(response);
    }

    async function onSearchKey(key) {
      setKey(key);
      if (key !== undefined && key !== null && key !== '' && key.length >= 2) {
        const response = props.all ? await ttAPI.getAllAccountsByKey(key) : await ttAPI.getAllTestntelAccountsByKey(key);
        if (response !== null) {
            setData(response);
        }
        else {
            setData([]);
        }
      }
      else {
        refreshData();
      }
    };

    const getRandomInt = (max) => {
      return Math.floor(Math.random() * Math.floor(max));
    }


    const openTeamChat = () => {
      window.open(
      `${config.teamChatUrl.replace('<USERS>', data[selectedRowIndex].email).replace('<TOPIC_NAME>','Individual%20Chat')}`,
      '_blank'
      );
      handleClose();
    }

    const openTeamChats = (emails) => {console.log(`${config.teamChatUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>','Team%20Chat')}`)
      window.open(
      `${config.teamChatUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>','Team%20Chat')}`,
      '_blank'
      );
      handleClose();
    }

    const downloadHistory = () => {
      window.open(`${config.clientApi}/reports/audit/account?id=${data[selectedRowIndex].id}`,'_blank');
    }

    const handleClose = () => {
      setAnchorEl(null);
      setSelectedRowIndex(-1);
      setIsMenuOpen(false);
    };

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setIsMenuOpen(true);
    };

  return (
    <>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={data !== undefined && data !== null ? data.map(item => {
                   return [item.id,
                    item.signon,
                    item.name,
                    item.name,
                    item.level,
                    item.franchise_name,
                    item.account_access ? 'YES' : 'NO',
                    item.franchise_access ? 'YES' : 'NO',
                    item.customer_access ? 'YES' : 'NO',
                    item.proof_access ? 'YES' : 'NO',
                    item.technician_settings === undefined || item.technician_settings === null ? 'NO' : (item.technician_settings.fire_kit === undefined || item.technician_settings.fire_kit === null ? 'NO' : (item.technician_settings.fire_kit ? 'YES' : 'NO')),
                    item.active ? 'YES' : 'NO',
                    item.email,
                    item.phone
                   ]
            }) : []}
            columns={columns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              searchOpen: true,
              print: false,
              viewColumns: false,
              selectableRows: 'multiple',
              rowsPerPageOptions: [10,15,20,50,100],
              rowsPerPage: 100,
              selectableRowsOnClick: false,
              onSearchChange: searchText => delayedOnSearchKey(searchText),
              customSearch: (searchQuery, currentRow, columns) => {
                 return data.find(c=> c.id === currentRow[0]) !== undefined;
              },
              onSearchClose: () => {
                 refreshData();
              },
              /*onRowClick: row => {
                history.push({pathname:`/app/account/edit/${row[0]}`,
                                         state:{accountId: row[0]}
                                       });
              },*/
              onCellClick: (col, cellMeta) => {
                if (!isMenuOpen) {
                  setSelectedRowIndex(cellMeta.dataIndex);
                  if (cellMeta.colIndex !== columns.length - 1 ) {
                    history.push({pathname:`/app/account/edit/${data[cellMeta.dataIndex].id}`,
                                                   state:{accountId: data[cellMeta.dataIndex].id}
                                                 });
                  }
                }


              },
              textLabels: { body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' }, },
              rowsPerPage: 100,
              rowsPerPageOptions: [10,20,50,100],
              onTableInit: (action, tableState) => {
                if (localStorage.getItem('accounts_filter_list') === undefined || localStorage.getItem('accounts_filter_list') === null || JSON.parse(localStorage.getItem('accounts_filter_list'))[11].length == 0) {
                   tableState.filterList[11] = ['YES'];
                   localStorage.setItem('accounts_filter_list', JSON.stringify(tableState.filterList));
                 }
              },
              customToolbar: () => {
                return (
                  <Link href="#/app/account/add" underline="none" color="#fff">
                    <Tooltip title="Add Account">
                     <IconButton><AddIcon /></IconButton>
                     </Tooltip>
                    </Link>

                );
              },
              customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                    return (<Tooltip title="Open Chat">
                     <IconButton onClick={() => {
                        //console.log(selectedRows.data);
                        var emails = '';
                          selectedRows.data.map(function (d) {
                              emails += data[d.dataIndex].email + ',';
                          });
                          if (emails !== null && emails !== undefined && emails !== '') {
                              emails = emails.slice(0, -1);
                              openTeamChats(emails);
                          }
                          }}><ChatIcon /></IconButton>
                     </Tooltip>);


              }
            }}
          />
        </MuiThemeProvider>
    </>
  );
});

export default AccountsTable;
